import { BaseContainerModel } from '../../../base-container.model';
import { bl_del_job_hdr_RowClass } from '../../../../dbschema/bl_del_job_hdr.model';
import { bl_del_job_ext_RowClass } from '../../../../dbschema/bl_del_job_ext.model';
import { bl_del_job_dochdr_link_RowClass, bl_del_job_docline_link_RowClass } from '../../../../dbschema';

export class JobContainerModel extends BaseContainerModel {
  bl_del_job_hdr: bl_del_job_hdr_RowClass = new bl_del_job_hdr_RowClass();
  bl_del_job_ext: bl_del_job_ext_RowClass[] = [];
  bl_del_job_dochdr_link: bl_del_job_dochdr_link_RowClass = new bl_del_job_dochdr_link_RowClass();
  bl_del_job_docline_link: bl_del_job_docline_link_RowClass [] = [];
}